// no conflict
var $ = jQuery.noConflict();

function add_sticky_nav() {

  header_height = $('.header').outerHeight();
  doc_scrollTop = $(document).scrollTop();

  timeout = setTimeout(function() {
      clearTimeout(timeout);
      timeout = null;
      
      if (doc_scrollTop > header_height ) {
          $('.header').addClass('is-sticky');
      } else {
          $('.header').removeClass('is-sticky');
      }
  }, 100);

}

$(document).ready(function() {
  add_sticky_nav();
});

$(window).scroll(function() {
  add_sticky_nav();
});